import React from 'react';
import { motion } from 'framer-motion';
import { NoirBackground } from '../components/GameUI';
import { ArrowLeft } from 'lucide-react';

const PrivacyPolicy = ({ onBack }) => (
  <div className="min-h-dvh flex flex-col items-center p-6 relative select-none">
    <NoirBackground />
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
      className="w-full max-w-md space-y-6 relative z-10 py-8">
      <button onClick={onBack} data-testid="privacy-back-btn"
        className="flex items-center gap-2 font-mono text-[#5A5A5A] text-xs uppercase tracking-wider hover:text-[#EF4444] transition-colors">
        <ArrowLeft size={14} /> Back
      </button>
      <div>
        <h1 className="font-typewriter text-4xl text-[#E0DDD5]">Privacy Policy</h1>
        <div className="red-line w-full mt-3" />
      </div>
      <div className="space-y-5 text-sm text-[#888] font-mono leading-relaxed">
        <p>Last updated: February 2026</p>
        <div>
          <h2 className="text-[#E0DDD5] font-bold uppercase tracking-wider text-xs mb-2">Data Collection</h2>
          <p>IMPOSTER is a pass-and-play party game that runs entirely in your browser. We do not collect, store, or transmit any personal data. Player names entered during gameplay are stored only in your device's memory and are erased when you close the app.</p>
        </div>
        <div>
          <h2 className="text-[#E0DDD5] font-bold uppercase tracking-wider text-xs mb-2">Cookies & Local Storage</h2>
          <p>We do not use cookies or local storage to track users. No data persists between sessions.</p>
        </div>
        <div>
          <h2 className="text-[#E0DDD5] font-bold uppercase tracking-wider text-xs mb-2">Third-Party Services</h2>
          <p>We use Google AdSense to display advertisements. Google may use cookies to serve ads based on your prior visits to this or other websites. You can opt out of personalized advertising by visiting Google's Ads Settings.</p>
        </div>
        <div>
          <h2 className="text-[#E0DDD5] font-bold uppercase tracking-wider text-xs mb-2">Children's Privacy</h2>
          <p>This game does not knowingly collect information from children under 13. The game is designed for group entertainment and requires no account creation or personal information submission.</p>
        </div>
        <div>
          <h2 className="text-[#E0DDD5] font-bold uppercase tracking-wider text-xs mb-2">Changes</h2>
          <p>We may update this policy from time to time. Any changes will be reflected on this page.</p>
        </div>
      </div>
    </motion.div>
  </div>
);

export default PrivacyPolicy;
